import EmailTemplatesIcon from "../../../components/Common/SvgIcons/AdminIcons/EmailTemplatesIcon";
import UserDetailsIcon from "../../../components/Common/SvgIcons/AdminIcons/UserManagementIcons/UserDetailsIcon";
import CertificateSettingsIcon from "../../../components/Common/SvgIcons/DistributeIcons/CertificateSettingsIcon";
import { mode } from "../../formModes";
import { colors } from "../../stripeColors";
import { distribute } from "./distribute";
import * as yup from "yup";

export const notificationSettingsSchema = yup.object().shape({
  NoDaysToNotifyBeforeDueDate: yup.string().required("This field is required."),
});

export const certificateSettingsSchema = yup.object().shape({
  Title: yup.string(),
  Certificate: yup
    .array(
      yup.object().shape({
        CertificateID: yup.string(),
        Name: yup.string(),
      })
    )
    .nullable(),
});

export const distributionDetailsSchema = yup.object().shape({
  Name: yup.string().required("The name is required."),
  Tags: yup
    .array(
      yup.object().shape({
        TagName: yup.string(),
        TagValue: yup.string(),
      })
    )
    .min(1, "The tagging is required."),
  DueDate: yup.string().when("CanDisplayClassPostDuedate", {
    is: true,
    then: yup.string(),
    otherwise: yup.string().required("Due-date is required"),
  }),
  IsSelfPacedProgram: yup.boolean(),
  IsSpreadProgram: yup.boolean(),
  CanDisplayClassPostDuedate: yup.boolean(),
  ImageUrl: yup.mixed().required("The Image is Required."),
});

export let createSeries = {
  name: "Create Series",
  label: "Create Series",
  copyLabel: "Copy Series",
  editLabel: "Edit Series",
  path: (tenantName) => `/${tenantName}/distribute/createSeries`,
  copyPath: (tenantName) => `/${tenantName}/distribute/copySeries`,
  editPath: (tenantName) => `/${tenantName}/distribute/editSeries`,
  navLinks: (navigate, tenantName, location, params) => [
    {
      key: 1,
      label: distribute.name,
      path: distribute.path(tenantName),
      onClick: () => navigate(`${distribute.path(tenantName)}`),
    },
    {
      key: 2,
      label: location.pathname.includes(
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
        ? createSeries.copyLabel
        : location.pathname.includes(
            `${createSeries.editPath(tenantName)}/${params?.programId}`
          )
        ? createSeries.editLabel
        : createSeries.label,
      path: `${createSeries.path(tenantName)}`,
      // onClick: () =>
      //   location.pathname ===
      //   `${createSeries.copyPath(tenantName)}/${params?.programId}`
      //     ? navigate(
      //         `${createSeries.copyPath(tenantName)}/${params?.programId}`
      //       )
      //     : `${createSeries.editPath(tenantName)}/${params?.programId}`
      //     ? navigate(
      //         `${createSeries.editPath(tenantName)}/${params?.programId}`
      //       )
      //     : navigate(`${createSeries.path(tenantName)}`),
    },
  ],
  tiles: (tenantName, location, params) => [
    {
      key: 1,
      label: "Series Details",
      path: location.pathname.includes(
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
        ? `${createSeries.copyPath(tenantName)}/${
            params?.programId
          }/seriesDetails`
        : location.pathname.includes(
            `${createSeries.editPath(tenantName)}/${params?.programId}`
          )
        ? `${createSeries.editPath(tenantName)}/${
            params?.programId
          }/seriesDetails`
        : `${createSeries.path(tenantName)}/seriesDetails`,
      color: colors.purple,
      isCompleted: false,
      icon: (fill) => <UserDetailsIcon fill={fill} />,
    },
    {
      key: 2,
      label: "Notification Settings",
      path: location.pathname.includes(
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
        ? `${createSeries.copyPath(tenantName)}/${
            params?.programId
          }/notificationSettings`
        : location.pathname.includes(
            `${createSeries.editPath(tenantName)}/${params?.programId}`
          )
        ? `${createSeries.editPath(tenantName)}/${
            params?.programId
          }/notificationSettings`
        : `${createSeries.path(tenantName)}/notificationSettings`,
      color: colors.green,
      isCompleted: false,
      icon: (fill) => <EmailTemplatesIcon fill={fill} />,
    },
    {
      key: 3,
      label: "Certificate Settings",
      path: location.pathname.includes(
        `${createSeries.copyPath(tenantName)}/${params?.programId}`
      )
        ? `${createSeries.copyPath(tenantName)}/${
            params?.programId
          }/certificateSettings`
        : location.pathname.includes(
            `${createSeries.editPath(tenantName)}/${params?.programId}`
          )
        ? `${createSeries.editPath(tenantName)}/${
            params?.programId
          }/certificateSettings`
        : `${createSeries.path(tenantName)}/certificateSettings`,
      color: colors.red,
      isCompleted: false,
      icon: (fill) => <CertificateSettingsIcon fill={fill} />,
    },
  ],
  notificationSettings: {
    name: "Notification Settings",
    path: (tenantName) =>
      `${createSeries.path(tenantName)}/notificationSettings`,
    formFields: (formMode) => [
      {
        key: 1,
        label: "Notify",
        name: "NoDaysToNotifyBeforeDueDate",
        labelColor: "dark",
        required: true,
        width: "10",
        type: "number",
        min: "1",
        max: "99",
        disable: formMode === mode.COPY ? true : false,
      },
    ],
  },
  distributionDetails: {
    name: "Series Details",
    path: (tenantName) => `${createSeries.path(tenantName)}/seriesDetails`,
    formFields: (
      fileChange,
      handleSearchTags,
      validTagSearch,
      searchTagsList,
      handleClickFileButton,
      seriesNameChanage,
      setIsNameExistLoader,
      formMode
    ) => [
      {
        key: 1,
        label: "Series Name",
        name: "Name",
        labelColor: "light",
        placeholder: "Enter Series Name",
        required: true,
        onChange: seriesNameChanage,
        loading: setIsNameExistLoader,
        disable: formMode === mode.EDIT ? true : false,
      },
      {
        key: 2,
        label: "Search Tags",
        name: "Tags",
        labelColor: "light",
        required: true,
        type: "tags",
        fieldName: "TagName",
        fieldValue: "TagValue",
        placeholder: "Enter multiple Tags Here",
        onChange: handleSearchTags,
        isValidTagSearch: validTagSearch,
        searchTagsList: searchTagsList,
        disable:
          formMode === mode.COPY || formMode === mode.EDIT ? true : false,
      },
      {
        key: 3,
        label: "Due Date",
        name: "DueDate",
        placeholder: "Enter End Date",
        labelColor: "light",
        required: true,
        type: "date",
      },
      {
        key: 4,
        label: "Self Paced Series",
        name: "IsSelfPacedProgram",
        type: "checkbox",
        labelColor: "light",
        direction: "row-reverse",
        width: "2",
        height: "2",
        disable: formMode === mode.COPY ? true : false,
        info: "Learner can complete the series at his own pace. It allows learner to complete one Shotclass at a time and the next Shotclass will be pushed after completion of the former.",
      },
      {
        key: 5,
        label: "Stretched Series",
        name: "IsSpreadProgram",
        labelColor: "light",
        direction: "row-reverse",
        width: "2",
        height: "2",
        type: "checkbox",
        disable: formMode === mode.COPY ? true : false,
        info: "Shotclasses are assigned at a uniform stretch based on the due date. It allows learner to get Shotclasses based on pending Shotclasses and due date.",
      },
      {
        key: 6,
        label: "Do Not Use Duedate",
        name: "CanDisplayClassPostDuedate",
        labelColor: "light",
        direction: "row-reverse",
        width: "2",
        height: "2",
        type: "checkbox",
        disable: formMode === mode.COPY ? true : false,
        info: "The distributed series will no longer have a due date if the selection is made.",
      },
      {
        key: 7,
        label: "Select Thumbnail",
        name: "ImageUrl",
        labelColor: "light",
        hidden: true,
        type: "file",
        required: true,
        accept: ".png, .jpg, .gif, .bmp",
        width: "21",
        onChange: fileChange,
        handleClickFileButton: handleClickFileButton,
      },
    ],
  },
  certificateSettings: {
    name: "Certificate Settings",
    path: (tenantName) =>
      `${createSeries.path(tenantName)}/certificateSettings`,
    formFields: (certificateLoading, certificateData) => [
      {
        key: 1,
        label: "Add Certificate",
        placeholder: "Select Certificate",
        name: "Certificate",
        labelColor: "light",
        type: "select",
        fieldName: "Name",
        fieldValue: "CertificateID",
        valueArr: certificateData,
        loading: certificateLoading,
      },
      {
        key: 2,
        label: "Certificate Title",
        name: "Title",
        labelColor: "light",
        placeholder: "Enter Certificate Title",
      },
    ],
  },
};
